import { SWEDISH_AREA_CODES, SWEDISH_MOBILE_PREFIX, SWEDISH_NON_GEOGRAPHIC_PREFIX } from './phone-numbers';

export const CURRENCY_PATTERN = '\\B(?=(\\d{3})+(?!\\d))';
export const NUMERIC_WHITESPACE_ALLOWED = /^[0-9\s]*$/;
export const DATE_YYYY_MM_DD = /^\d{4}-\d{2}-\d{2}$/;
export const WHITESPACE_SLASH = '\\s+|-';
export const WHITESPACE = /\s/g;
export const NON_NUMERIC = /\D/g;
export const NON_NUMERIC_EXCEPT_WHITESPACE = /[^\s\d]/g;
export const DIGITS_BETWEEN_5_AND_20_ALLOW_START_WITH_PLUS = '^\\+?\\d{5,20}$';
export const EMAIL_PATTERN = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// Check for a valid calendar year, month and day of an SSN so it will match ['YYMMDD-XXXX' | 'YYYYMMDD-XXXX'] format
export const SSN_PATTERN = /^([12]{1}[90]{1})?[0-9]{2}([0]{1}[1-9]{1}|[1]{1}[0-2])([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-1]{1}|[6]{1}[1-9]{1}|[7-8]{1}[0-9]{1}|[9]{1}[0-1]{1})-?[0-9]{4}$/;

export const AREA_CODE = new RegExp('^' + SWEDISH_AREA_CODES.join('|'));
export const MOBILE_PREFIX = new RegExp('^' + SWEDISH_MOBILE_PREFIX.join('|'));
export const NON_GEOGRAPHIC_PREFIX = new RegExp('^' + SWEDISH_NON_GEOGRAPHIC_PREFIX.join('|'));
